export const GET_TAX_ENTRIES_FOR_APPROVAL = 'getTaxEntriesForApproval';
